import React, { PropsWithChildren, createContext, useState } from "react";
import { AttributeContextType, TEditingItemAttribute, TdeleteInfo } from "./types";


export const AttributeContext = createContext<AttributeContextType>({} as AttributeContextType);

export const AttributeContextProvider = ({ children }: PropsWithChildren) => {
  let [listReloadCounter, setListReloadCounter] = React.useState<number>(0);
  let [editingItem, setEditingItem] = React.useState<TEditingItemAttribute|null>(null);
  let [deleteinfo, setDeleteInfo] = useState<TdeleteInfo>({
    status: null,
    message: "",
  });
  const [attributeId, setAttributeId] = useState<string>("");
  const [newAttributeId, setNewAttributeId] = useState<string>("");
  const [updatedAttributeId, setUpdatedAttributeId] = useState<string>("");
  const [attributeDeleted, setAttributeDeleted] = useState<boolean>(false);
  const [attributeLoading, setAttributeLoading] = useState<boolean>(false)

  return (
    <AttributeContext.Provider
      value={{
        listReloadCounter,
        editingItem,
        setEditingItem,
        setListReloadCounter,
        deleteinfo,
        setDeleteInfo,
        attributeId,
        setAttributeId,
        newAttributeId,
        setNewAttributeId,
        updatedAttributeId,
        setUpdatedAttributeId,
        attributeDeleted,
        setAttributeDeleted,
        attributeLoading,
        setAttributeLoading
      }}
    >
      {children}
    </AttributeContext.Provider>
  );
};
